var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 28,
    viewBox: "0 0 64 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 28,
    rx: 8,
    fill: "#F75157"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7266 19.5156V21H13.8555V6.85938H15.4766V19.5156H21.7266ZM24.207 6.85938H25.8281V21H24.207V6.85938ZM39.3828 6.85938L34.793 21H32.9766L28.3867 6.85938H30.1445L33.8945 19.1836L37.6445 6.85938H39.3828ZM50.418 19.5352V21H41.9023V6.85938H50.1836V8.32422H43.5234V13.0312H48.5039V14.5156H43.5234V19.5352H50.418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/live-icon.d55df05637c47b4e611c345a5bf9a287.svg";
export { ForwardRef as ReactComponent };